export const LightLogo = "/images/thequickassist-logo-light.webp";
export const DarkLogo = "/images/thequickassist-logo-dark.webp";
export const ArrowGif = "/images/arrow.gif";
export const DemoBotImg = "/images/demo-bot-img.webp";
export const DemoBotImgDark = "/images/demo-bot-img-dark.webp";
export const DemoWebImg = "/images/demo-web-img.webp";
export const DemoWebImgDark = "/images/demo-web-img-dark.webp";
export const FacebookIcon = "/images/facebook.webp";
export const InstagramIcon = "/images/instagram.webp";
export const TwitterIcon = "/images/tweeter.webp";
export const BotImg = "/images/chatting-ai.webp";
export const PoweredBy = "/images/poweredBy.webp";
export const PartyPopper = "/images/party-popper-svgrepo-com.svg";
